import { TProgramGrade } from '../../types'

const isProgramGrade = (value: unknown): value is TProgramGrade => {
  if (!value || typeof value !== 'object') return false

  const candidate = value as Partial<TProgramGrade>

  return (
    typeof candidate.label === 'string' &&
    typeof candidate.from === 'number' &&
    typeof candidate.to === 'number' &&
    typeof candidate.color === 'string'
  )
}

export const getGradeRowsFromFormValues = (
  formValues: Record<string, unknown>,
  rowCount: number,
): TProgramGrade[] => {
  return Array.from(
    { length: rowCount },
    (_, index) => formValues[index],
  ).filter(isProgramGrade)
}

export const findPassingGradeIndexByLabel = (
  values: TProgramGrade[],
  passingGradeLabel?: string,
): number => {
  if (!passingGradeLabel) return -1

  return values.findIndex(({ label }) => label === passingGradeLabel)
}
